module.exports = __webpack_public_path__ + "static/media/11.bd56a96f.jpg";